export default "__VITE_ASSET__C7rm9JCT__"